

































































declare let AMap: any;
declare let AMapUI: any;
import * as _ from "lodash";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Tab, Tabs, ActionSheet, Search, Checkbox, CheckboxGroup, Cell, CellGroup, Field, DatetimePicker } from "vant";
import trafficPolicyService from "@/service/trafficPolicyService";
import dataShare from "../../dataShare";
import Bubble from "@/views/system/modules/bubble.vue";
import { ServiceSecne } from "@/model/Base";
import baseService from "@/service/baseService";
import moment from "moment";

@Component({
  name: "taxi",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [ActionSheet.name]: ActionSheet,
    [Search.name]: Search,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
  },
})
export default class taxi extends Vue {
  created() {
    sessionStorage.setItem("NoPermission", "false");
  }

  @Prop()
  TripRuleData: any;

  back() {
    history.back();
  }
  // city = "上海";
  statusCode = "now";
  get departureTime() {
    return (this as any).$moment(this.currentDate).format("YYYY-MM-DD HH:mm");
  }
  serviceScene = { name: "商务用车", value: ServiceSecne.Business };
  isShowScene = false;

  scenes = [
    { name: "商务用车", value: ServiceSecne.Business },
    { name: "加班用车", value: ServiceSecne.Work },
    { name: "出差用车", value: ServiceSecne.Btrip },
    { name: "其它场景", value: ServiceSecne.Other },
  ];

  selectScene(scene?: any) {
    this.serviceScene = scene;
    this.$emit("changeScene", scene.value);
  }

  departAddress = {
    cityId: "",
    detail: "",
    latitude: "",
    longitude: "",
  };

  locationData?: any;
  locationMatchCity() {
    if (!this.locationData || !this.citys || this.citys.length == 0) {
      return;
    }
    let trimCity = function(str: string) {
      if (str) {
        return str.replace(/市$/, "");
      }
      return str;
    };
    let cityName = trimCity(this.locationData.regeocode && this.locationData.regeocode.addressComponent && this.locationData.regeocode.addressComponent.city) || "上海";
    let cityInfo: any[] = this.citys.filter((o: any) => trimCity(o.CityName) == cityName);
    if (cityInfo && cityInfo[0]) {
      this.departCity = cityInfo[0];
      this.intentCity = Object.assign({}, cityInfo[0]);
    }
    this.departAddress.cityId = this.departCity.CityID;
    this.arriveAddress.cityId = this.intentCity.CityID;
  }

  setAddressData(value?: any) {
    this.locationData = value;
    this.departAddress = {
      cityId: "",
      detail: value.address,
      latitude: value.position.lat + "",
      longitude: value.position.lng + "",
    };
    this.locationMatchCity();
  }
  // {"detail":"上海市黄浦区吴家弄与河南南路交叉口西50米","latitude":"31.227182","longitude":"121.487322"}

  // arriveAddress: any = { detail: "上海市黄浦区吴家弄与河南南路交叉口西50米", latitude: "31.227182", longitude: "121.487322" };
  arriveAddress = {
    cityId: "",
    detail: "",
    latitude: "",
    longitude: "",
  };
  isShowAddressSearch = false;
  isSelectData = false;
  get minDate() {
    return moment(new Date())
      .add(30, "minute")
      .seconds(0)
      .subtract(1, "second")
      .toDate();
  }
  get maxDate() {
    return moment(new Date())
      .add(3, "day")
      .hours(0)
      .minutes(0)
      .seconds(0)
      .subtract(1, "second")
      .toDate();
  }
  currentDate: Date = new Date();

  get activeCity() {
    return this.addressType == "arrival" ? this.intentCity : this.departCity;
  }

  departCity: any = {
    CityID: "11181",
    CityName: "上海",
  };
  intentCity: any = {
    CityID: "11181",
    CityName: "上海",
  };

  activated() {
    if (this.City && (this as any).City.ZoneID) {
      let city = this.addressType == "arrival" ? this.intentCity : this.departCity;
      city.CityID = this.City.ZoneID;
      city.CityName = this.City.label;
    }
  }

  mounted() {
    this.loadCityData();
    this.addressDetail = this.departAddress.detail;
    (window as any).__taxi = this;
  }

  isCityPopup = false;
  dataShare = dataShare;
  get City(): any {
    return this.dataShare.City;
  }
  set City(value: any) {
    this.dataShare.City = value;
  }
  changeCity(cityType: string) {
    if (this.addressType == "arrival") {
      this.City = this.intentCity;
    } else {
      this.City = this.departCity;
    }
    this.$router.push({
      path: "/selectCity",
      query: {
        ServiceType: "TrafficService",
        // ApplyArea: this.query.ApplyArea + "",
      },
    });
  }

  addressType = "";
  // 地址搜索
  addressPopup(key: string) {
    this.addressLists = [];
    this.addressType = key;
    if (key == "departure") {
      this.addressDetail = this.departAddress.detail;
    } else {
      this.addressDetail = this.arriveAddress.detail;
    }
    this.isShowAddressSearch = true;
  }

  addressDetail = "";
  get placeholder() {
    if (this.addressType == "departure") {
      return "您在哪上车？";
    } else {
      return "您要去哪儿？";
    }
  }

  addressLists: any = [];
  searchAddress(value: string) {
    if (!value) {
      return;
    }
    let data = {
      ZoneId: this.activeCity.CityID + "",
      Keyword: value,
    };
    trafficPolicyService.getAddress(data).then(res => {
      if (res.isSucc) {
        this.addressLists = res.result;
      }
    });
  }
  select(value: any) {
    let departAddress = this.departAddress;
    if (value.longitude && value.latitude) (this.$refs.mapCtl as any).setCenter({ lng: value.longitude, lat: value.latitude });
    if (this.addressType == "departure") {
      this.departAddress = value;
      this.isShowAddressSearch = false;
      if (!this.arriveAddress.detail) {
        return;
      }
      departAddress = value;
    }

    let arriveAddress = this.arriveAddress;
    if (this.addressType == "arrival") {
      if (!this.departAddress.detail) {
        this.arriveAddress = value;
        this.isShowAddressSearch = false;
        return;
      }
      arriveAddress = value;
    }

    departAddress.cityId = this.departCity.CityID;
    arriveAddress.cityId = this.intentCity.CityID;
    let departureTime = undefined;
    if (this.statusCode == "reservation") {
      departureTime = (this as any).$moment(this.currentDate).format("YYYY-MM-DD HH:mm:ss");
    }
    this.$router.push({
      path: "/mall/traffic/taxiList",
      query: {
        scene: this.serviceScene.value + "",
        departAddress: JSON.stringify(departAddress),
        arriveAddress: JSON.stringify(arriveAddress),
        departureTime: departureTime,
        FeatureCodes: this.TripRuleData.FeatureCodes,
      },
    });
    this.isShowAddressSearch = false;
  }

  @Watch("addressDetail")
  handleAddressDetail(val?: any) {
    if (this.addressType == "departure") {
      return this.departAddress.detail;
    } else {
      return this.arriveAddress.detail;
    }
  }
  citys = [];

  loadCityData() {
    const data = {
      ZoneType: "1444",
      ZoneTypes: "",
      ZoneName: "",
      CountryID: 151,
      Props: "CityID,CityName",
      PageSize: 10000,
    };
    baseService.getZoneList(data).then(res => {
      if (!res.isSucc || !res.result || !res.result.entities) {
        return;
      }
      this.citys = res.result.entities;
      this.locationMatchCity();
    });
  }
}
